import DeleteModalComponent from "./DeleteModalComponent";

export default DeleteModalComponent;
